module.exports = __webpack_public_path__ + "assets/fa8f4bcc4dab606f00e0d263ba30d097.mp3";